import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../utils/Button';
import Logo from '../../ui/components/Logo';
import { useSelector } from 'react-redux';

export const CartHeader = () => {
  return (
    <header className="fixed bg-white w-full lg:flex lg:justify-between items-center pt-4 px-6 py-2 lg:px-[76p] z-50 lg:border-b-2">
      <div className="flex items-center space-x-4">
        <Logo />
        <h1 className="font-semibold text-[25px] hidden lg:block">Checkout</h1>
      </div>
      <div className="mx-auto">
        <h1 className="font-semibold text-[25px] flex justify-center lg:hidden">
          Checkout
        </h1>
      </div>

      <div className="hidden lg:block">
        <CancelPurchase />
      </div>
    </header>
  );
};

export const CancelPurchase = () => {
  const isProcessing = useSelector(
    (state) =>
      Boolean(state.fullPayment.paystackOrderReference) &&
      !state.fullPayment.downPaymentSuccess
  );

  return (
    <div className="border-[#ECEDF1 rounded-lg overflow-clip p-1">
      <Link
        className={`flex space-x-1 items-center p-2 border rounded-lg ${
          isProcessing
            ? 'opacity-40 pointer-events-none cursor-not-allowed bg-[#FAFAFA]'
            : 'hover:shadow-lg bg-[#FAFAFA]'
        }`}
        to="/cart-items"
        aria-disabled={isProcessing}
        onClick={(e) => isProcessing && e.preventDefault()}
      >
        <X color="#EF4237" />
        <span className="font-normal text-sm">Cancel purchase</span>
      </Link>
    </div>
  );
};
